import React from "react";
import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaAws,
  FaDocker,
  FaDatabase,
  FaMobileAlt,
  FaBrain,
} from "react-icons/fa";
import "./TechnologiesUsed.css";

const TechnologiesUsed = () => {
  return (
    <section className="oglitz-tech-dark">
      <div className="oglitz-tech-dark-inner">
        {/* Badge */}
        <span className="oglitz-tech-badge">Technology Stack</span>

        {/* Heading */}
        <h2 className="oglitz-tech-title">
          Built With <span>Modern, Scalable</span> Technologies
        </h2>

        {/* Description */}
        <p className="oglitz-tech-desc">
          We use industry-proven frameworks, cloud platforms, and modern tools
          to build secure, scalable, and future-ready digital products for
          global businesses.
        </p>

        {/* Grid */}
        <div className="oglitz-tech-dark-grid">
          <div className="oglitz-tech-dark-card react">
            <FaReact />
            <h4>React & React Native</h4>
            <span>Frontend & Mobile</span>
          </div>

          <div className="oglitz-tech-dark-card node">
            <FaNodeJs />
            <h4>Node.js</h4>
            <span>Backend Services</span>
          </div>

          <div className="oglitz-tech-dark-card python">
            <FaPython />
            <h4>Python</h4>
            <span>AI & Automation</span>
          </div>

          <div className="oglitz-tech-dark-card aws">
            <FaAws />
            <h4>Cloud Platforms</h4>
            <span>AWS · Azure · GCP</span>
          </div>

          <div className="oglitz-tech-dark-card docker">
            <FaDocker />
            <h4>Docker & DevOps</h4>
            <span>CI/CD Pipelines</span>
          </div>

          <div className="oglitz-tech-dark-card database">
            <FaDatabase />
            <h4>Databases</h4>
            <span>MongoDB · MySQL</span>
          </div>

          <div className="oglitz-tech-dark-card mobile">
            <FaMobileAlt />
            <h4>Mobile Platforms</h4>
            <span>Android · iOS</span>
          </div>

          <div className="oglitz-tech-dark-card ai">
            <FaBrain />
            <h4>AI / Machine Learning</h4>
            <span>Smart Systems</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologiesUsed;
